import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import ProductDetail from './components/ProductDetail';
import CheckoutPage from './components/CheckoutPage';
import { PaymentSuccess, PaymentFailed } from './components/PaymentStatus';
import FloatWA from './components/FloatWA';
import Footer from './components/Footer';
import ScrollUp from './components/ScrollUp';
import ScrollToTop from './components/ScrollToTop';

function App() {
    return (
        <Router>
            <div>
                <Navbar />
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/product" element={<ProductDetail />} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/payment-success" element={<PaymentSuccess />} />
                    <Route path="/payment-failed" element={<PaymentFailed />} />
                </Routes>
                <FloatWA />
                <ScrollUp />
                <Footer />
            </div>
        </Router>
    );
}

export default App;
